import { CmsRegistrationRoot } from '../cms/cms-registration-root.interface';
import { CmsProtectionBenefitsAccordion } from './cms-protection-benefits-accordion.interface';
import { CmsProtectionDetailsApplianceCarePanelHeader } from './cms-protection-details-appliance-care-panel-header.interface';
import { CmsProtectionDetailsExclusions } from './cms-protection-details-exclusions.interface';
import { CmsProtectionDetailsHeader } from './cms-protection-details-header.interface';
import { CmsProtectionDetailsMultiRegistration } from './cms-protection-details-multi-registration.interface';
import { CmsProtectionDetails } from './cms-protection-details.interface';

export interface CmsProtectionDetailsPage
  extends CmsProtectionBenefitsAccordion,
    CmsProtectionDetails,
    CmsProtectionDetailsApplianceCarePanelHeader,
    CmsProtectionDetailsHeader,
    CmsProtectionDetailsMultiRegistration,
    CmsProtectionDetailsExclusions,
    CmsRegistrationRoot {
  pageTitle: string;
}
